import { createRouter } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";

/**
 * Singleton TanStack Router. File-based route tree is generated (well, hand-
 * maintained in U1; see `routeTree.gen.ts`).
 */
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
